module.exports = __webpack_public_path__ + "static/media/PUBLICACIONES.a8b8010b.pdf";